import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInjector, UnauthorizedInterceptorService } from '@coin/shared/auth/data-access';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInjector, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptorService, multi: true }
];
